'use client'

import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { authClient } from '@/lib/auth/client'

export function LogoutButton({ className, label = 'Esci' }: { className?: string; label?: string }) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  async function signOut() {
    setLoading(true)
    try {
      // Termina l'eventuale impersonificazione prima di uscire.
      await fetch('/api/portal/impersonate/stop', { method: 'POST' }).catch(() => undefined)
      await authClient.signOut()
    } finally {
      router.push('/portal/login')
      router.refresh()
    }
  }

  return (
    <button
      type="button"
      onClick={signOut}
      disabled={loading}
      className={className ?? 'text-[12px] font-semibold uppercase tracking-[0.14em] text-[color:var(--league-muted)] hover:text-[color:var(--league-brand)]'}
    >
      {loading ? 'Uscita…' : label}
    </button>
  )
}
